<div class="show-for-sr" role="status" aria-live="polite" aria-atomic="true">{{announceText}}</div>
@if (showLoader) {
  <div class="overlay">
    <static-loader [text]="text" color="white" [announce]="false"></static-loader>
  </div>
}
